module.exports = __webpack_public_path__ + "static/media/torre-expositor.4dffa58d.svg";